import { render } from "./AddGreenHouse.vue?vue&type=template&id=189ca725"
import script from "./AddGreenHouse.vue?vue&type=script&lang=js"
export * from "./AddGreenHouse.vue?vue&type=script&lang=js"

import "./AddGreenHouse.vue?vue&type=style&index=0&id=189ca725&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__